import { render } from "./CardContact.vue?vue&type=template&id=77a48a27"
import script from "./CardContact.vue?vue&type=script&lang=js"
export * from "./CardContact.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__